/* =========================================================================
   Hush theme JS — REAL Shopify cart wiring.
   - Offer ladder selects a product VARIANT (data-variant-id from Liquid).
   - "Add to cart" POSTs to /cart/add.js (AJAX), then the drawer reads /cart.js.
   - Checkout button goes to Shopify checkout (/checkout).
   - Subscription option: set data-selling-plan on the Subscribe offer once your
     subscription app creates a selling plan (see comment in sections/hero.liquid).
   ========================================================================= */
(function () {
  var H = window.HUSH || {};
  var ROUTES = H.routes || { cartAdd: "/cart/add.js", cart: "/cart.js", cartChange: "/cart/change.js", cartClear: "/cart/clear.js" };
  if (!ROUTES.cartClear) ROUTES.cartClear = "/cart/clear.js";
  var MONEY_FORMAT = H.moneyFormat || "${{amount}}";
  var PRODUCT_TITLE = H.productTitle || "Your item";
  var PRODUCT_IMAGE = H.productImage || "";
  // variant id -> theme product image, so the cart line shows the clean restyled photo
  // (Shopify's /cart.js image comes from the ADMIN product image, which can lag or differ).
  var PRODUCT_IMG = {};
  (H.products || []).forEach(function (p) { if (p && p.id && p.image) PRODUCT_IMG[String(p.id)] = p.image; });
  // 2026-10-08 evening: Corner Scratcher versions — clean theme photo + readable version name on each drawer line
  // (the admin variant titles are raw supplier strings). Set in layout/theme.liquid.
  var VARIANT_LABEL = H.variantLabels || {};
  Object.keys(H.variantImages || {}).forEach(function (k) { PRODUCT_IMG[k] = H.variantImages[k]; });

  /* ---- Shopify money formatter (handles the shop's money_format string) ---- */
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelims(num, precision, thousands, decimal) {
      precision = (precision == null) ? 2 : precision;
      thousands = thousands || ","; decimal = decimal || ".";
      if (isNaN(num) || num == null) return "0";
      num = (num / 100.0).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }
    var match = MONEY_FORMAT.match(placeholder);
    var token = match ? match[1] : "amount";
    var value;
    switch (token) {
      case "amount_no_decimals": value = withDelims(cents, 0); break;
      case "amount_with_comma_separator": value = withDelims(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelims(cents, 0, ".", ","); break;
      default: value = withDelims(cents, 2);
    }
    return MONEY_FORMAT.replace(placeholder, value);
  }

  /* ---- HEADLINE VARIANTS (design behaviour, unchanged) ---- */
  var HEADLINES = {
    meno: "For the nights, heat, and mood shifts everyone keeps brushing off."
  };
  window.setHeadline = function (key) {
    var el = document.querySelector("#headline .pain");
    if (!el || !HEADLINES[key]) return;
    el.textContent = HEADLINES[key];
  };
  window.setHeadline("meno");

  /* ---- OFFER SELECTOR — tracks the chosen variant + display price ---- */
  var form        = document.getElementById("offer-form");
  var offers      = form ? Array.prototype.slice.call(form.querySelectorAll(".offer")) : [];
  var stickyPrice = document.getElementById("sticky-price");
  var stickyComp  = document.getElementById("sticky-compare");
  var current     = null;

  function selectOffer(offer) {
    offers.forEach(function (o) {
      var on = o === offer;
      o.classList.toggle("selected", on);
      var input = o.querySelector("input");
      if (input) input.checked = on;
    });
    current = {
      variantId:   offer.getAttribute("data-variant-id"),
      qty:         parseInt(offer.getAttribute("data-qty"), 10) || 1,   // multi-bottle tier → quantity added
      unit:        offer.getAttribute("data-unit") || "",               // original per-bottle price (for the cart line)
      sellingPlan: offer.getAttribute("data-selling-plan") || "",
      price:       offer.getAttribute("data-price") || "",
      cartPrice:   offer.getAttribute("data-cart-price") || offer.getAttribute("data-price") || "",
      cartSub:     offer.getAttribute("data-cart-sub") || "",
      compare:     offer.getAttribute("data-compare") || ""
    };
    if (stickyPrice) stickyPrice.textContent = current.price;
    if (stickyComp) {
      stickyComp.textContent = current.compare;
      stickyComp.style.display = current.compare ? "block" : "none";
    }
  }
  offers.forEach(function (offer) {
    offer.addEventListener("click", function () { selectOffer(offer); });
    var input = offer.querySelector("input");
    if (input) input.addEventListener("change", function () { selectOffer(offer); });
  });
  if (offers.length) selectOffer(form.querySelector(".offer.selected") || offers[0]);

  // Reflect the REAL cart in the buy-box selector: if this product is already in the cart,
  // pre-select the tier matching its quantity — so the page doesn't keep snapping back to the
  // 3-bottle default after a refresh. (Empty cart → keep the "Best value" 3-bottle default.)
  function syncSelectorToCart(cart) {
    if (!form || !offers.length) return;
    var offerVid = offers[0].getAttribute("data-variant-id");
    if (!offerVid) return;
    var line = null;
    ((cart && cart.items) || []).forEach(function (it) {
      if (String(it.variant_id) === String(offerVid)) line = it;
    });
    if (!line) return;                                  // not in cart → leave the default selection
    var match = null;
    offers.forEach(function (o) {
      if (parseInt(o.getAttribute("data-qty"), 10) === line.quantity) match = o;
    });
    if (match) selectOffer(match);                      // qty matches a tier → reflect it
  }

  /* ---- CART DRAWER (reads real Shopify cart) ---- */
  var overlay     = document.getElementById("drawer-overlay");
  var drawer      = document.getElementById("drawer");
  var drawerClose = document.getElementById("drawer-close");
  var cartLines   = document.getElementById("cart-lines");
  var cartEmpty   = document.getElementById("cart-empty");
  var cartError   = document.getElementById("cart-error");
  var totalEl     = document.getElementById("drawer-total");
  var upsellTitle = document.getElementById("upsell-title");
  var upsellSub   = document.getElementById("upsell-sub");
  var upsellTarget = null;   // the complementary product the drawer cross-sell will add
  var hdCartCount = document.getElementById("hd-cart-count");   // header cart-icon badge

  // Header cart badge — total item count; hidden at 0. Works for real and optimistic carts.
  function updateCartCount(cart) {
    if (!hdCartCount) return;
    var n = ((cart && cart.items) || []).reduce(function (s, it) { return s + (it.quantity || 0); }, 0);
    if (n > 0) { hdCartCount.textContent = n > 99 ? "99+" : String(n); hdCartCount.hidden = false; }
    else { hdCartCount.hidden = true; }
  }
  var upsellCard  = document.getElementById("upsell");
  var upsellAdd   = document.getElementById("upsell-add");
  var cartCache   = null;   // last-known cart, so the drawer can open instantly

  // 2026-08-28 audit: move focus into the drawer on open, restore it on close, close on Escape.
  var drawerReturnFocus = null;
  function openDrawer() {
    if (!drawer) return;
    drawerReturnFocus = document.activeElement;
    overlay.classList.add("open");
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var closeBtn = document.getElementById("drawer-close");
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove("open");
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (drawerReturnFocus && drawerReturnFocus.focus) drawerReturnFocus.focus();
    drawerReturnFocus = null;
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("open")) closeDrawer();
  });
  // toggles a slim loading bar (CSS .drawer.busy) so async work shows progress
  function setBusy(on) { if (drawer) drawer.classList.toggle("busy", !!on); }

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  // Clean brand name for the cart line — strips a " — Menopause Support"-style suffix so
  // the optimistic line ("Hush Daily Relief") and the real cart line
  // ("Hush Daily Relief — Menopause Support") are identical and never visibly swap.
  function cleanTitle(t) {
    return String(t || "").split(/\s+[—–-]\s+/)[0].trim();
  }

  function renderCart(cart, skipCache) {
    if (!cartLines) return;
    if (cart && !skipCache) cartCache = cart;   // keep the cache fresh for instant opens (skip for optimistic)
    cartLines.innerHTML = "";
    var empty = !cart || !cart.items || cart.items.length === 0;
    if (cartEmpty) cartEmpty.hidden = !empty;
    updateCartCount(cart);   // keep the header cart-icon badge in sync
    syncUpsell(cart);   // offer the complementary product (or hide if cart empty / already complete)
    if (empty) { if (totalEl) totalEl.textContent = formatMoney(0); return; }

    cart.items.forEach(function (item) {
      var line = document.createElement("div");
      line.className = "cart-line";
      var imgSrc = PRODUCT_IMG[String(item.variant_id)] || item.image;   // prefer the clean theme photo
      var thumb = imgSrc
        ? '<img class="thumb" src="' + escapeHtml(imgSrc) + '" alt="" style="object-fit:cover;background:#fff;">'
        : '<div class="ph thumb"></div>';
      var sub = item.selling_plan_allocation
        ? item.selling_plan_allocation.selling_plan.name
        : (VARIANT_LABEL[String(item.variant_id)] || "One-time purchase");   // matches the optimistic line so the subtitle doesn't swap
      var key = escapeHtml(item.key);
      // quantity stepper: each button carries the TARGET quantity (− = n-1, + = n+1, × = 0)
      var qctl =
        '<div class="qty">' +
          '<button type="button" class="qty-btn" data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<span class="qty-n">' + item.quantity + "</span>" +
          '<button type="button" class="qty-btn" data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '<button type="button" class="qty-remove" data-key="' + key + '" data-qty="0" aria-label="Remove item">&times;</button>' +
        "</div>";
      // PRICE CELL (display only — never touches what Shopify charges):
      //  • unit line "N × $44.99" so a multi-bottle line reads as bottles, not one lump sum
      //  • when an automatic discount applied (final_line_price < original_line_price), strike
      //    the pre-discount total and show the discounted total the cart actually charges.
      var unitPrice = (item.original_price != null) ? item.original_price : item.price;
      var fullLine  = (item.original_line_price != null) ? item.original_line_price : (unitPrice * item.quantity);
      var nowLine   = item.final_line_price;
      var unitLine  = '<div class="ci-unit">' + item.quantity + " × " + formatMoney(unitPrice) + "</div>";
      var priceHtml = (nowLine < fullLine)
        ? '<span class="ci-was">' + formatMoney(fullLine) + '</span><span class="ci-now">' + formatMoney(nowLine) + "</span>"
        : formatMoney(nowLine);
      line.innerHTML =
        thumb +
        '<div><div class="ci-name">' + escapeHtml(cleanTitle(item.product_title)) + "</div>" +
        (sub ? '<div class="ci-sub">' + escapeHtml(sub) + "</div>" : "") +
        unitLine +
        qctl + "</div>" +
        '<div class="ci-price">' + priceHtml + "</div>";
      cartLines.appendChild(line);
    });
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  // Instantly paint the selected product in the drawer (no network) so the CTA feels
  // immediate even on a cold page load. The real cart fetch reconciles right after.
  function renderOptimistic() {
    if (!cartLines || !current) return;
    // Build an optimistic cart from the last-known REAL cart + the selected item (+1),
    // then render it through renderCart so the title, quantity, line price and subtotal
    // all match what the server returns — the network reconcile becomes invisible
    // (no "qty 1 → real qty" jump, no "Hush Daily Relief → … — Menopause Support" swap).
    var optimistic = (cartCache && cartCache.items)
      ? JSON.parse(JSON.stringify(cartCache))
      : { items: [], total_price: 0 };
    var vid = String(current.variantId);
    // MULTI-PRODUCT CART: keep any OTHER products already in the basket; only this product's
    // own line is replaced with the freshly selected quantity. (Caps + gummies can coexist;
    // the drawer cross-sells whichever one isn't in the cart yet.)
    function _cents(s) { return Math.round(parseFloat(String(s || "0").replace(/[^0-9.]/g, "")) * 100) || 0; }
    optimistic.items = (optimistic.items || []).filter(function (it) { return String(it.variant_id) !== vid; });
    var qtyN    = current.qty || 1;
    var lineNow = _cents(current.cartPrice || current.price);                              // selected tier ORDER total (post-discount)
    var unitC   = _cents(current.unit) || (qtyN ? Math.round(lineNow / qtyN) : lineNow);   // original per-bottle price
    // The product NAME is the real product, never the tier label ("3 bottles") — the tier is
    // just a quantity chooser, so the cart line is one product at qty N. Image comes from the
    // buy box the shopper clicked; the global HUSH config is only a fallback.
    var pageThumb = document.querySelector(".offer-thumb");
    optimistic.items.push({
      key: "optimistic-" + vid,
      variant_id: current.variantId,
      product_title: PRODUCT_TITLE,
      quantity: qtyN,
      price: unitC,
      final_price: qtyN ? Math.round(lineNow / qtyN) : lineNow,
      original_price: unitC,                  // pre-discount per-bottle → cart line shows "N × $unit"
      line_price: unitC * qtyN,
      original_line_price: unitC * qtyN,      // pre-discount line total → struck through
      final_line_price: lineNow,             // post-discount line total → the amount charged
      image: (pageThumb && pageThumb.src) || PRODUCT_IMAGE || "",
      selling_plan_allocation: current.sellingPlan
        ? { selling_plan: { name: current.cartSub || "Subscribe & save" } }
        : null
    });
    optimistic.total_price = optimistic.items.reduce(function (s, it) { return s + (it.final_line_price || 0); }, 0);
    renderCart(optimistic, true);   // true = don't overwrite the real-cart cache
  }

  function getCart() {
    return fetch(ROUTES.cart, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  function addToCart(variantId, sellingPlan, qty) {
    var item = { id: Number(variantId), quantity: qty || 1 };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);  // subscription selling plan (set on the offer)
    return fetch(ROUTES.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (data) {
        // surface Shopify add errors (e.g. variant unavailable, bad selling plan)
        if (!r.ok) { var err = new Error(data.description || data.message || "Add to cart failed"); err.data = data; throw err; }
        return data;
      });
    });
  }
  // Empty the cart (used by the primary CTA so it starts a clean single-item order)
  function clearCart() {
    return fetch(ROUTES.cartClear, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" }
    }).then(function (r) { return r.json(); });
  }

  // Change a line's quantity by its line-item KEY. quantity 0 removes the line.
  // Apply the change, then ALWAYS re-fetch /cart.js (single source of truth) and
  // re-render — so displayed quantities, the empty state, and the subtotal match
  // Shopify's real cart after every −, +, and × action.
  function changeQty(key, quantity) {
    setBusy(true);
    return fetch(ROUTES.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })   // change applied
      .then(getCart)                              // re-fetch /cart.js as the source of truth
      .then(function (cart) { renderCart(cart); setBusy(false); })
      .catch(function () {
        // on failure, re-sync the drawer from the real cart (undo optimistic UI)
        setBusy(false);
        getCart().then(renderCart).catch(function () {});
      });
  }

  // Show a clear, customer-friendly reason in the drawer when an add can't go through,
  // so a failed add NEVER reads as a silent "empty cart, $0.00".
  function showAddError(e) {
    if (!cartError) return;
    var raw = (e && e.data && (e.data.description || e.data.message)) || (e && e.message) || "";
    var msg = /sold out|unavailable|out of stock/i.test(raw)
      ? "Sorry — this item is sold out right now. Please check back soon."
      : (raw || "Sorry — we couldn't add that to your cart. Please try again.");
    cartError.textContent = msg;
    cartError.hidden = false;
    if (cartEmpty) cartEmpty.hidden = true;    // don't show the generic "empty" line under an error
  }
  function clearAddError() { if (cartError) cartError.hidden = true; }

  function addSelectedAndOpen() {
    clearAddError();                           // reset any prior error on each new attempt
    openDrawer();                              // open instantly — no waiting on the network
    renderOptimistic();                        // paint the selected product immediately
    setBusy(true);
    var finish = function (cart) { renderCart(cart); setBusy(false); };
    var fail   = function (e) { setBusy(false); showAddError(e); getCart().then(renderCart).catch(function () {}); };
    if (!current || !current.variantId) {      // product/variants not set up yet
      setBusy(false);
      showAddError({ message: "This product isn't available to purchase yet." });
      getCart().then(renderCart).catch(function () {});
      return;
    }
    // MULTI-PRODUCT CART: the CTA sets THIS product's line to the selected quantity, but
    // leaves OTHER products in the basket untouched — so caps + gummies can coexist. It still
    // de-dupes its own product (no stacked/wrong-qty duplicate lines of the same variant).
    // Shoppers add the other half via the drawer cross-sell (or buy The Hush System bundle).
    // Computed from the REAL cart (fetched fresh), never from a possibly-stale cache.
    var wantPlan = String(current.sellingPlan || "");
    var wantQty  = current.qty || 1;                      // multi-bottle tier → 1, 2, or 3 bottles
    getCart().then(function (cart) {
      var keysToRemove = [], alreadyCorrect = false;
      ((cart && cart.items) || []).forEach(function (it) {
        if (String(it.variant_id) !== String(current.variantId)) return;   // leave OTHER products alone
        var linePlan = it.selling_plan_allocation ? String(it.selling_plan_allocation.selling_plan.id) : "";
        if (linePlan === wantPlan && it.quantity === wantQty && !alreadyCorrect) {
          alreadyCorrect = true;                          // exact desired line for THIS product — keep it
        } else {
          keysToRemove.push(it.key);                      // dup / wrong-qty line of THIS product — remove
        }
      });
      if (alreadyCorrect && keysToRemove.length === 0) return getCart().then(finish);
      var chain = Promise.resolve();
      keysToRemove.forEach(function (key) {
        chain = chain.then(function () {
          return fetch(ROUTES.cartChange, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      });
      return chain
        .then(function () {
          if (alreadyCorrect) return;                     // desired line survived the cleanup
          return addToCart(current.variantId, current.sellingPlan, wantQty)
            .catch(function (e) {                         // plan rejected → keep cart working as one-time
              if (current.sellingPlan) return addToCart(current.variantId, "", wantQty);
              throw e;
            });
        })
        .then(getCart).then(finish);
    }).catch(fail);
  }

  ["cta-main", "cta-sticky"].forEach(function (id) {
    var btn = document.getElementById(id);
    if (btn) btn.addEventListener("click", function (e) { e.preventDefault(); addSelectedAndOpen(); });
  });

  // Header cart icon — open instantly from cache, then refresh from the server
  var hdCart = document.getElementById("hd-cart");
  if (hdCart) hdCart.addEventListener("click", function (e) {
    e.preventDefault();
    clearAddError();                           // a manual cart open shouldn't carry a stale add-error
    openDrawer();
    if (cartCache) renderCart(cartCache);
    setBusy(true);
    getCart().then(function (cart) { renderCart(cart); setBusy(false); }).catch(function () { setBusy(false); });
  });

  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (drawerClose) drawerClose.addEventListener("click", closeDrawer);

  // Quantity steppers + remove — event-delegated so it keeps working after each re-render
  if (cartLines) cartLines.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest("[data-qty]") : null;
    if (!btn) return;
    var key = btn.getAttribute("data-key");
    var qty = parseInt(btn.getAttribute("data-qty"), 10);
    if (!key || isNaN(qty)) return;
    // optimistic feedback so the tap feels instant; server reconciles on re-render
    var lineEl = btn.closest(".cart-line");
    if (lineEl) {
      lineEl.querySelectorAll("button").forEach(function (b) { b.disabled = true; });
      if (qty <= 0) {
        lineEl.style.opacity = ".45";
      } else {
        var n = lineEl.querySelector(".qty-n");
        if (n) n.textContent = qty;
      }
    }
    changeQty(key, qty);
  });

  // CROSS-SELL — cat store: offer the catnip spray when the cart has items but no spray yet.
  // syncUpsell (called from renderCart) picks the target from window.HUSH.products (the spray,
  // set in theme.liquid) and sets the labels; tapping adds it as its own line. Hidden when the
  // cart is empty or already holds every configured product.
  function syncUpsell(cart) {
    if (!upsellCard) return;
    var products = H.products || [];
    var items = (cart && cart.items) || [];
    upsellTarget = null;
    if (!products.length || !items.length) { upsellCard.style.display = "none"; return; }
    var inCart = {};
    items.forEach(function (it) { inCart[String(it.variant_id)] = true; });
    for (var i = 0; i < products.length; i++) {
      if (products[i] && products[i].id && !inCart[String(products[i].id)]) { upsellTarget = products[i]; break; }
    }
    if (!upsellTarget) { upsellCard.style.display = "none"; return; }   // cart already has every product
    upsellCard.style.display = "";
    // 2026-08-28 audit: sub aligned with the sharpened PDP add-on angle (fear-led, not feature-led)
    if (upsellTitle) upsellTitle.textContent = "Make it her favorite spot faster";
    if (upsellSub)   upsellSub.textContent   = upsellTarget.title + " · makes the board the spot she goes to first.";
    if (upsellAdd)   upsellAdd.textContent   = "+ Add";
  }

  if (upsellAdd) upsellAdd.addEventListener("click", function () {
    if (!upsellTarget) return;                 // nothing to cross-sell
    upsellAdd.disabled = true;
    setBusy(true);
    var done = function () { upsellAdd.disabled = false; setBusy(false); };
    addToCart(upsellTarget.id, "", 1).then(getCart).then(function (c) { renderCart(c); done(); })
      .catch(function () { done(); getCart().then(renderCart).catch(function () {}); });
  });

  // GIFT toggle — show/hide the note field
  var giftCheck  = document.getElementById("gift-check");
  var giftFields = document.getElementById("gift-fields");
  var giftNote   = document.getElementById("gift-note");
  if (giftCheck && giftFields) {
    giftCheck.addEventListener("change", function () {
      if (giftCheck.checked) { giftFields.removeAttribute("hidden"); if (giftNote) giftNote.focus(); }
      else giftFields.setAttribute("hidden", "");
    });
  }

  // Checkout — if "send as a gift" is ticked, save the note to the ORDER note first, then go.
  var checkoutBtn = document.getElementById("drawer-checkout");
  if (checkoutBtn) checkoutBtn.addEventListener("click", function () {
    var go = function () { window.location.href = "/checkout"; };
    if (giftCheck && giftCheck.checked && giftNote && giftNote.value.trim()) {
      setBusy(true);
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ note: "🎁 GIFT NOTE: " + giftNote.value.trim() })
      }).then(go).catch(go);   // never block checkout if the note save fails
    } else { go(); }
  });

  // "Empty cart" — one-tap reset in the drawer. POSTs /cart/clear.js (server truth),
  // then re-renders. Visible only when the cart has items (toggled in renderCart's caller
  // here, mirroring the upsell row's empty-state behaviour).
  var drawerClear = document.getElementById("drawer-clear");
  function syncClearBtn(cart) {
    if (drawerClear) drawerClear.style.display = (cart && cart.items && cart.items.length) ? "" : "none";
  }
  if (drawerClear) drawerClear.addEventListener("click", function () {
    setBusy(true);
    drawerClear.disabled = true;
    fetch(ROUTES.cartClear, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: "{}" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); syncClearBtn(cart); drawerClear.disabled = false; setBusy(false); })
      .catch(function () {
        drawerClear.disabled = false; setBusy(false);
        getCart().then(function (c) { renderCart(c); syncClearBtn(c); }).catch(function () {});
      });
  });
  // keep the button's visibility in sync whenever the real cart renders
  var _renderCart = renderCart;
  renderCart = function (cart, skipCache) { _renderCart(cart, skipCache); syncClearBtn(cart); };

  // Warm the cart on page load so the FIRST drawer open is instant and correct,
  // and sync the buy-box selector to whatever quantity is actually in the cart.
  if (cartLines) getCart().then(function (cart) { renderCart(cart); syncSelectorToCart(cart); }).catch(function () {});

  /* ---- HEADER hamburger (static show/hide, no animation) ---- */
  var hdBurger = document.getElementById("hd-burger");
  var hdMenu   = document.getElementById("hd-menu");
  if (hdBurger && hdMenu) {
    hdBurger.addEventListener("click", function () {
      var willOpen = hdMenu.hasAttribute("hidden");
      if (willOpen) hdMenu.removeAttribute("hidden"); else hdMenu.setAttribute("hidden", "");
      hdBurger.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
    hdMenu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        hdMenu.setAttribute("hidden", "");
        hdBurger.setAttribute("aria-expanded", "false");
      });
    });
  }
})();
